import React, { useEffect, useState } from 'react';
import Modal from './ui/Modal';
import Btn from './ui/Btn';
import { Input } from './ui/Input';
import { produtosApi } from '../api/produtos';
import { COLORS } from '../theme';
import { useAuth } from '../context/AuthContext';

const LIMITE = 20;

function formatarReal(v) {
  if (v === null || v === undefined || v === '') return '-';
  return `R$ ${Number(v).toFixed(2).replace('.', ',')}`;
}

// Remove as setinhas de incremento/decremento dos <input type="number"> só dentro deste
// modal — mantém a validação/teclado numérico do type="number", só tira o widget visual.
const ESTILO_SEM_SPINNER = (
  <style>{`
    .campo-sem-spinner::-webkit-outer-spin-button,
    .campo-sem-spinner::-webkit-inner-spin-button { -webkit-appearance: none; margin: 0; }
    .campo-sem-spinner { -moz-appearance: textfield; }
  `}</style>
);

const TABELAS = [
  { chave: 'varejo', label: 'Varejo', campoValor: 'margem_varejo_valor' },
  { chave: 'geral', label: 'Geral', campoValor: 'margem_geral_valor' },
  { chave: 'promocao', label: 'Promoção', campoValor: 'margem_promocao_valor' },
  { chave: 'licitacao', label: 'Licitação', campoValor: 'margem_licitacao_valor' },
  { chave: 'minimo_gerente', label: 'Mín. Gerente', campoValor: 'margem_minimo_gerente_valor' },
  { chave: 'minimo', label: 'Mínimo', campoValor: 'margem_minimo_valor' }
];

function LinhaProduto({ produto, semRestricao, onAdicionar }) {
  const [precos, setPrecos] = useState(undefined);
  const [tabelaSelecionada, setTabelaSelecionada] = useState('geral');
  const [valor, setValor] = useState('');
  const [quantidade, setQuantidade] = useState('1');
  const [erro, setErro] = useState('');
  const [adicionado, setAdicionado] = useState(false);

  useEffect(() => {
    produtosApi.obterPrecosCustos(produto.id).then(dados => {
      setPrecos(dados);
      setValor(dados?.margem_geral_valor ? Number(dados.margem_geral_valor).toFixed(2) : '');
    }).catch(() => setPrecos({}));
  }, [produto.id]);

  const escolherTabela = (tabela) => {
    if (!semRestricao && ['licitacao', 'minimo_gerente', 'minimo'].includes(tabela.chave)) return;
    setTabelaSelecionada(tabela.chave);
    const v = precos?.[tabela.campoValor];
    if (v !== undefined && v !== null) setValor(Number(v).toFixed(2));
  };

  const pisoValor = precos?.margem_promocao_valor !== undefined && precos?.margem_promocao_valor !== null
    ? Number(precos.margem_promocao_valor) : null;
  const abaixoDoPiso = !semRestricao && pisoValor !== null && Number(valor || 0) < pisoValor;

  const adicionar = () => {
    setErro('');
    if (!quantidade || Number(quantidade) <= 0) { setErro('Informe a quantidade'); return; }
    if (!valor || Number(valor) <= 0) { setErro('Informe o valor'); return; }
    onAdicionar({
      produto_id: produto.id, produto_codigo: produto.codigo, produto_nome: produto.nome, quantidade, valor_unitario: valor,
      desconto_pct: '0', ipi_pct: '0', margem_promocao_valor: pisoValor, valor_aprovado_gerente: null
    });
    setAdicionado(true);
    setTimeout(() => setAdicionado(false), 1200);
  };

  return (
    <div style={{ borderBottom: `1px solid ${COLORS.border}`, padding: '6px 12px' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'nowrap' }}>
        <div style={{ fontSize: 12.5, flex: '1 1 auto', minWidth: 0, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} title={`${produto.codigo} — ${produto.nome}`}>
          <strong>{produto.codigo}</strong> — {produto.nome}
          {produto.codigo_fabricante && <span style={{ color: COLORS.textLight }}> · {produto.codigo_fabricante}</span>}
        </div>

        {precos === undefined ? (
          <span style={{ fontSize: 11, color: COLORS.textMid, flexShrink: 0 }}>carregando...</span>
        ) : (
          <div style={{ display: 'flex', alignItems: 'center', gap: 4, flexShrink: 0 }}>
            {TABELAS.map(tabela => {
              const restrita = !semRestricao && ['licitacao', 'minimo_gerente', 'minimo'].includes(tabela.chave);
              const selecionada = tabelaSelecionada === tabela.chave;
              const v = precos[tabela.campoValor];
              return (
                <button
                  key={tabela.chave}
                  type="button"
                  disabled={restrita}
                  onClick={() => escolherTabela(tabela)}
                  title={restrita ? 'Restrita — pede autorização do gestor' : `${tabela.label}: ${formatarReal(v)}`}
                  style={{
                    padding: '4px 7px', borderRadius: 6, fontSize: 10.5, fontWeight: 600, cursor: restrita ? 'not-allowed' : 'pointer',
                    whiteSpace: 'nowrap',
                    border: `1.5px solid ${selecionada ? COLORS.primary : COLORS.border}`,
                    background: selecionada ? COLORS.primaryBg : '#fff',
                    color: selecionada ? COLORS.primary : (restrita ? COLORS.textLight : COLORS.textMid),
                    opacity: restrita ? 0.55 : 1
                  }}>
                  {tabela.label}: {formatarReal(v)}
                </button>
              );
            })}

            <Input type="number" step="0.001" value={quantidade} onChange={e => setQuantidade(e.target.value)}
              className="campo-sem-spinner" style={{ width: 46, marginLeft: 6, padding: '5px 6px' }} placeholder="Qtd" />
            <div style={{ display: 'flex', alignItems: 'stretch', border: `1.5px solid ${COLORS.border}`, borderRadius: 7, overflow: 'hidden', background: COLORS.bg }}>
              <span style={{ padding: '5px 4px 5px 7px', fontSize: 11, color: COLORS.textMid, display: 'flex', alignItems: 'center' }}>R$</span>
              <Input type="number" step="0.01" value={valor} onChange={e => setValor(e.target.value)}
                className="campo-sem-spinner" style={{ width: 62, padding: '5px 6px 5px 0', border: 'none', borderRadius: 0 }} placeholder="0,00" />
            </div>
            <button
              type="button"
              onClick={adicionar}
              title="Adicionar"
              style={{
                width: 28, height: 28, flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center',
                borderRadius: 7, border: 'none', cursor: 'pointer',
                background: adicionado ? '#1a9c5c' : (abaixoDoPiso ? COLORS.warning : COLORS.primary),
                color: '#fff', fontSize: 16, fontWeight: 700, lineHeight: 1
              }}>
              {adicionado ? '✓' : '+'}
            </button>
          </div>
        )}
      </div>
      {erro && <p style={{ color: COLORS.danger, fontSize: 11, margin: '2px 0 0', textAlign: 'right' }}>{erro}</p>}
      {!erro && abaixoDoPiso && (
        <p style={{ color: '#92400E', fontSize: 11, margin: '2px 0 0', textAlign: 'right' }}>
          Abaixo da Promoção ({formatarReal(pisoValor)}) — a proposta vai para negociação com o gestor.
        </p>
      )}
    </div>
  );
}

export default function SelecionarItensPropostaModal({ itensAtuais, onAdicionarItem, onRemoverItem, onFechar }) {
  const { usuario } = useAuth();
  const semRestricao = usuario?.perfil !== 'vendedor' || usuario?.autorizado_tabela_completa;

  const [busca, setBusca] = useState('');
  const [pagina, setPagina] = useState(1);
  const [produtos, setProdutos] = useState([]);
  const [temMais, setTemMais] = useState(false);
  const [carregando, setCarregando] = useState(false);

  const buscar = (paginaAlvo, buscaAlvo, acumular) => {
    setCarregando(true);
    produtosApi.listar({ busca: buscaAlvo, pagina: paginaAlvo, limite: LIMITE, suspenso: 'false' })
      .then(lista => {
        setProdutos(prev => acumular ? [...prev, ...lista] : lista);
        setTemMais(lista.length === LIMITE);
      })
      .catch(() => {})
      .finally(() => setCarregando(false));
  };

  useEffect(() => {
    const t = setTimeout(() => { setPagina(1); buscar(1, busca, false); }, 300);
    return () => clearTimeout(t);
  }, [busca]); // eslint-disable-line

  const verMais = () => {
    const proxima = pagina + 1;
    setPagina(proxima);
    buscar(proxima, busca, true);
  };

  const totalGeral = itensAtuais.reduce((s, i) => s + (Number(i.quantidade) || 0) * (Number(i.valor_unitario) || 0), 0);

  return (
    <Modal titulo="Selecionar Produtos" onFechar={onFechar} largura={1800}
      rodape={<Btn onClick={onFechar}>Concluir</Btn>}>
      {ESTILO_SEM_SPINNER}
      <div style={{ display: 'grid', gridTemplateColumns: '3fr 1fr', gap: 16, alignItems: 'start' }}>
        <div>
          <Input
            placeholder="Buscar por código, nome, descrição ou código do fabricante..."
            value={busca}
            onChange={e => setBusca(e.target.value)}
            autoFocus
            style={{ marginBottom: 10 }}
          />

          <div style={{ border: `1px solid ${COLORS.border}`, borderRadius: 8, maxHeight: 500, overflowY: 'auto' }}>
            {produtos.map(p => (
              <LinhaProduto key={p.id} produto={p} semRestricao={semRestricao} onAdicionar={onAdicionarItem} />
            ))}
            {!carregando && produtos.length === 0 && (
              <p style={{ fontSize: 13, color: COLORS.textMid, textAlign: 'center', padding: 20 }}>Nenhum produto encontrado.</p>
            )}
            {carregando && produtos.length === 0 && (
              <p style={{ fontSize: 13, color: COLORS.textMid, textAlign: 'center', padding: 20 }}>Buscando...</p>
            )}
          </div>

          {temMais && (
            <div style={{ textAlign: 'center', marginTop: 10 }}>
              <Btn variante="ghost" onClick={verMais} disabled={carregando}>{carregando ? 'Carregando...' : 'Ver mais'}</Btn>
            </div>
          )}
        </div>

        <div style={{ position: 'sticky', top: 0 }}>
          <div style={{ fontSize: 12, fontWeight: 700, color: COLORS.textMid, textTransform: 'uppercase', letterSpacing: '0.04em', marginBottom: 8 }}>
            Itens Adicionados ({itensAtuais.length})
          </div>
          <div style={{ border: `1px solid ${COLORS.border}`, borderRadius: 8, maxHeight: 500, overflowY: 'auto' }}>
            {itensAtuais.map((item, idx) => (
              <div key={idx} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 8, padding: '8px 10px', borderBottom: `1px solid ${COLORS.border}` }}>
                <div style={{ fontSize: 12 }}>
                  <div><strong>{item.produto_codigo}</strong> — {item.produto_nome}</div>
                  <div style={{ color: COLORS.textMid }}>{item.quantidade} × {formatarReal(item.valor_unitario)} = {formatarReal(Number(item.quantidade) * Number(item.valor_unitario))}</div>
                </div>
                <button type="button" onClick={() => onRemoverItem(idx)}
                  style={{ background: 'none', border: 'none', color: COLORS.danger, cursor: 'pointer', fontSize: 16, lineHeight: 1, padding: 2 }}>
                  ×
                </button>
              </div>
            ))}
            {itensAtuais.length === 0 && (
              <p style={{ fontSize: 12, color: COLORS.textMid, textAlign: 'center', padding: 16 }}>Nenhum item ainda. Adicione produtos na lista à esquerda.</p>
            )}
          </div>
          {itensAtuais.length > 0 && (
            <div style={{ textAlign: 'right', marginTop: 8, fontSize: 14, fontWeight: 700 }}>
              Total: {formatarReal(totalGeral)}
            </div>
          )}
        </div>
      </div>
    </Modal>
  );
}
